module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEyIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00LjEyOTAzIDlMMCA0LjcxMDY0TDAuNzkyNjI3IDMuODg3MjNMNC4xMjkwMyA3LjM1MzE5TDExLjIwNzQgMEwxMiAwLjgyMzQwNEw0LjEyOTAzIDlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/active-tag.svg
// module id = OYdg
// module chunks = 7